import React from 'react';
import { KnightKey, FaeKey } from '../types';
import { useSwornBuilderContext } from '../contexts/SwornBuilderContext';
import KnightCompendiumView from './panels/compendium/KnightCompendiumView';
import FaeCompendiumView from './panels/compendium/FaeCompendiumView';

interface CompendiumContentProps {
  selectedKnight?: KnightKey | null;
  selectedFae?: FaeKey | null;
  onClose?: () => void;
  selectedBlessings?: Set<string>;
  toggleBlessing?: (blessingName: string) => void;
}

const CompendiumContent: React.FC<CompendiumContentProps> = ({
  selectedKnight,
  selectedFae,
  onClose,
  selectedBlessings,
  toggleBlessing
}) => {
  const { clearBlessings } = useSwornBuilderContext();

  // --- KNIGHT VIEW ---
  if (selectedKnight) {
    return <KnightCompendiumView selectedKnight={selectedKnight} />;
  }

  // --- FAE VIEW ---
  if (selectedFae) {
    return (
        <FaeCompendiumView 
            selectedFae={selectedFae} 
            selectedBlessings={selectedBlessings} 
            toggleBlessing={toggleBlessing}
            clearBlessings={clearBlessings}
        />
    );
  }

  // Default empty state
  return (
    <div className="h-full bg-slate-900/95 backdrop-blur-sm rounded-lg border border-sworn-brown p-4 flex items-center justify-center">
      <div className="text-center text-slate-400 animate-pulse">
        <div className="text-4xl mb-2">📚</div>
        <p>Select a Knight or Fae to view details</p>
      </div>
    </div>
  );
};

export default CompendiumContent;
